import React from 'react'
import Box from '@mui/material/Box'
import { Doughnut } from 'react-chartjs-2'
import * as CHART_UTILS from './Doughnut.constant'

const DoughnutChart = ({ chartLabels, dataGroup, backgroundColors }) => {
  return (
    <Box sx={{ width: '100%', height: '400px' }}>
      <Doughnut
        data={{
          labels: chartLabels,
          datasets: [
            {
              ...CHART_UTILS.DOUGHNUT,
              data: dataGroup,
              borderWidth: 1,
              ...(backgroundColors && { backgroundColor: backgroundColors })
            }
          ]
        }}
        options={{
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right'
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const label = context.label || ''
                  const value = context.raw || 0
                  const total = context.dataset.data.reduce((a, b) => a + b, 0)
                  const percentage = Math.round((value / total) * 100)
                  return `${label}: ${value} min (${percentage}%)`
                }
              }
            }
          }
        }}
      />
    </Box>
  )
}

export default DoughnutChart
